import { observable } from 'mobx';
import moment from 'moment';

export default class Rozvoz {

    @observable public id: number;
    @observable public idKlient: number;
    @observable public datum: Date;
    @observable public adresa: string;
    @observable public stridavyRozvoz: string;
    @observable public poradi: number;
    @observable public trasa: string;

    public clone(): Rozvoz {
        const newDen: Rozvoz = new Rozvoz();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): Rozvoz {
        this.id = json.id;
        this.idKlient = json.id_klient;
        this.datum = moment(json.datum).toDate();
        this.adresa = json.adresa;
        this.stridavyRozvoz = json.stridavy_rozvoz;
        this.poradi = json.pradi;
        this.trasa = json.trasa;
        return this;
    }

    public loadFromEntity(ent: Rozvoz): Rozvoz {
        this.id = ent.id;
        this.idKlient = ent.idKlient;
        this.datum = ent.datum;
        this.adresa = ent.adresa;
        this.stridavyRozvoz = ent.stridavyRozvoz;
        this.poradi = ent.poradi;
        this.trasa = ent.trasa;
        return this;
    }

}


// WEBPACK FOOTER //
// ./src/models/Rozvoz.tsx